module.exports = __webpack_public_path__ + "static/media/cms-labels-icon.716201ea.svg";